import { Reveal } from "@/components/Reveal";

export const faqJsonLd = (faqs) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
});

export const Faq = ({ faqs, serviceName }) => (
  <section data-testid="faq-section" aria-labelledby="faq-heading" className="section section-alt">
    <div className="container-site">
      <Reveal className="max-w-[720px]">
        <h2 id="faq-heading">{serviceName} Questions, Answered</h2>
      </Reveal>
      <dl className="mt-10 max-w-[820px] divide-y divide-line border-y border-line">
        {faqs.map((f, i) => (
          <Reveal key={f.q} delay={i * 60} data-testid={`faq-item-${i + 1}`} className="py-6">
            <dt>
              <h3 className="text-xl">{f.q}</h3>
            </dt>
            <dd className="mt-3 text-base text-body">{f.a}</dd>
          </Reveal>
        ))}
      </dl>
    </div>
  </section>
);
